import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { Campus } from 'src/app/_models/campus';
import { Periodo } from 'src/app/_models/periodo';
import { Programa } from 'src/app/_models/programa';
import { CampusService } from 'src/app/_services/campus.service';
import { NuevoIngresoService } from 'src/app/_services/nuevo-ingreso.service';
import { PeriodoService } from 'src/app/_services/periodo.service';
import { InscripcionService } from "src/app/_services/inscripcion.service";
import { EstatusAcademico } from 'src/app/_models/inscripcion';
import { ApiResponse } from 'src/app/models/api/ApiRespose.model';
import { UsuarioIngreso } from 'src/app/_models/usuarionuevoingresodto';
import { I18NextPipe } from 'angular-i18next';
import { MatOption } from '@angular/material/core';
import { AttributesDto } from '@app/_models/AttributesDto';
import { AttributesService } from './../../../_services/attributes.service';
import { SolicitudApoyoFinancieroService } from '../../../_services/solicitud-apoyo-financiero.service';
import { FormatoProgramaDto } from '@app/_models/FormatoProgramaDto';
import { IdiomaProgramaDto } from '@app/_models/IdiomaProgramaDto';
import { IdiomaProgramaService } from '@app/_services/idioma-programa.service';
import { FormatoProgramaService } from '@app/_services/formato-programa.service';
import { SubprocesosService } from '@app/_services/subprocesos.service';
import { SubProcesoDto } from '@app/_models/SubProcesoDto';
@Component({
  selector: 'app-programa-academico-registro',
  templateUrl: './programa-academico-registro.component.html',
  styleUrls: ['./programa-academico-registro.component.scss']
})
export class ProgramaAcademicoRegistroComponent implements OnInit {
  public programaAcademicoForm: FormGroup;
  public renderizarFormulario: boolean = false;
  public nuevoSolicitudForm: FormGroup;
  public nuevoSolicitudUsuarioForm: FormGroup;
  public nombreCompletoUsuario: string;
  public datosUsuarioBusqueda$: Observable<UsuarioIngreso>;
  public datosUsuarioBusqueda: UsuarioIngreso;
  public subscritpionCampus: Subscription;
  public subscriptionPeriodo: Subscription;
  public subscriptionPrograma: Subscription;
  public campusList: Campus[] = [];
  public periodoList: Periodo[] = [];
  public estatusAcademicoList: EstatusAcademico[] = [];
  public programaList: Programa[] = [];
  public tipoAccion: number;
  public formularioProfesor: boolean = false;
  public campusChange: boolean = false;
  public tabCambiosPrograma: string = "";
  public nivelID: number;
  public materias: number;
  public estatusAcademicoId: number = 0;
  public subscription: Subscription = new Subscription();
  public identificadorPersonalizado: boolean = false;
  public attributes: AttributesDto[];
  public existenAtributos: boolean = false;
  public atributoF = new FormControl();
  @ViewChild('allAtritbuto') private allAtritbuto: MatOption;
  public filtroForm: FormGroup;
  public formatoProgramaList: FormatoProgramaDto[] = [];
  public idiomaProgramaList: IdiomaProgramaDto[] = [];
  public subProcesoList: SubProcesoDto[] = [];
  public existeVariosProcesos: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ProgramaAcademicoRegistroComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UsuarioIngreso,
    private campusService: CampusService,
    private periodoService: PeriodoService,
    public nuevoIngresoService: NuevoIngresoService,
    private InscripcionService: InscripcionService,
    private i18nextPipe: I18NextPipe,
    public attributesService: AttributesService,
    private solicitudApoyoFinancieroService: SolicitudApoyoFinancieroService,
    private formatoProgramaService: FormatoProgramaService,
    private idiomaProgramaService: IdiomaProgramaService,
    private subprocesosService: SubprocesosService
  ) { }

  async ngOnInit(): Promise<void> {
    // this.obtenerAtributos();
    return new Promise<void>((resolve) => {
      console.log("DATA PARA NUEVOS DATOS", this.data)
      this.inicializarFormAtributo().then((_) => {
        this.obtenerAtributos();
      });
      this.getTipoCampus();
      this.getTipoPeriodo();
      this.GetEstatusAcademicos();
      this.obtenerFormatoPrograma();
      this.obtenerIdiomaPrograma();
      this.getSubProcesos();
      this.datosUsuarioBusqueda$ = this.solicitudApoyoFinancieroService.obtenerDatosUsuarioBusqueda$();
      this.datosUsuarioBusqueda$.subscribe(datos => this.datosUsuarioBusqueda = datos)
      this.nuevoIngresoService.getMateriasCount().subscribe(element => this.materias = element);
      this.subscription.add(
        this.nuevoIngresoService.obteneridentificadorPersonalizado().subscribe((respuesta: ApiResponse<boolean>) => {
          if (respuesta.success) {
            this.identificadorPersonalizado = respuesta.data;
          } else {
            this.identificadorPersonalizado = false;
          }
        })
      )
      resolve();
    });
  }

  /**
* Metodo para traer catalogo
*/
  public obtenerFormatoPrograma() {
      this.formatoProgramaService.obtenerFormatoPrograma().subscribe((response: ApiResponse<FormatoProgramaDto[]>) => {
        this.formatoProgramaList = response.data;
      })
  }

  /**
  * Metodo para traer catalogo
  */
  public obtenerIdiomaPrograma() {
      this.idiomaProgramaService.obtenerIdiomaPrograma().subscribe((response: ApiResponse<IdiomaProgramaDto[]>) => {
        this.idiomaProgramaList = response.data;
      })
  }

    /**
 * Metodo para traer catalogo de subprocesos por institucion
 */
     public getSubProcesos() {
      this.subprocesosService.subProcesoInstitucion("NUEVO").subscribe(
        (response: ApiResponse<SubProcesoDto[]>) => {
          this.subProcesoList = response.data;
          if (this.subProcesoList.length <= 1) {
            this.existeVariosProcesos = false;
          } else {
            this.existeVariosProcesos = true;
          }
        })
    }

  /**
 * Metodo que consulta los bloques
 */
  public obtenerAtributos() {
    console.log("this.data.alumno[0].studentAttributes", this.data.alumno[0].studentAttributes)
    this.attributesService.attributesInstitucion().subscribe((respuesta: ApiResponse<AttributesDto[]>) => {
      this.attributes = respuesta.data;
      console.log("this.attributes", this.attributes)
      this.existenAtributos = this.attributes.length > 0;
      if (this.existenAtributos) {
        this.atributoF.setValue([...this.data.alumno[0].studentAttributes.map(item => item.attributeId)]);
        this.filtroForm.patchValue({
          atributoF: this.data.alumno[0].studentAttributes.map(item => item.attributeId)
        });
      }
    })
  }

  /**
* Metodo cuando se seleccionan todos los atributos
*/
  toggleAllSelectionAtributo() {
    // this.reiniciarTimer();
    if (this.allAtritbuto.selected) {
      this.filtroForm.patchValue({
        atributoF: this.attributes.map(item => item.attributeId)
      });
      this.atributoF.patchValue([...this.attributes.map(item => item.attributeId), 0]);
    } else {
      this.filtroForm.patchValue({
        atributoF: []
      });
      this.atributoF.patchValue([]);
    }
  }

  /**
* Verifica si el campo Todos del select atributo esta seleccionados, si lo esta
* quita la seleccion de todos los campos, sino los selecciona todos
* @param AtributoId
* @returns
*/
  tosslePerOneAtributo(AtributoId: number) {
    // this.reiniciarTimer();
    if (this.allAtritbuto.selected) {
      this.allAtritbuto.deselect();
    }
    if (this.atributoF.value.length == this.attributes.length) {
      this.allAtritbuto.select();
    }
    const AtributoSeleccionados = this.filtroForm.get('atributoF').value;
    const existeAtributo = AtributoSeleccionados.find(x => x === AtributoId);
    if (!existeAtributo) {
      const AtributoAnteriores = AtributoSeleccionados;
      AtributoAnteriores.push(AtributoId);
      this.filtroForm.patchValue({
        atributoF: AtributoAnteriores
      });
    } else {
      const AtributoFiltrados = AtributoSeleccionados.filter(x => x !== AtributoId);
      this.filtroForm.patchValue({
        atributoF: AtributoFiltrados
      });
    }
  }

  public async renderizarFormularioPrograma() {
    if (!this.attributes) {
      await this.ngOnInit().then((_) => {
        this.inicializarForm();
      });
    } else {
      this.inicializarForm();
    }
  }

  /**
 * Metodo que inicializa el form para los filtros
 */
  public inicializarFormAtributo(): Promise<void> {
    return new Promise<void>((resolve) => {
      this.filtroForm = new FormGroup({
        atributoF: new FormControl([])
      });
      this.atributoF.setValue(["-1"]);
      resolve();
    });
  }

  public inicializarForm() {
    console.log("datosUsuarioBusqueda", this.datosUsuarioBusqueda)
    this.programaAcademicoForm = new FormGroup({
      usuarioId: new FormControl(this.datosUsuarioBusqueda.usuarioId),
      campus: new FormControl(this.datosUsuarioBusqueda.alumno[0].programa.campusId, [Validators.required, this.validateId]),
      programaAcademico: new FormControl(this.datosUsuarioBusqueda.alumno[0].programa.programaId, [Validators.required, this.validateId]),
      periodo: new FormControl(this.datosUsuarioBusqueda.alumno[0].priodoIngresoNavigation.periodoId, [Validators.required, this.validateId]),
      estatusAdmision: new FormControl(this.datosUsuarioBusqueda.alumno[0].estatusAcademico, [Validators.required, this.validateId]),
      formatoPrograma: new FormControl(this.datosUsuarioBusqueda.alumno[0].formatoProgramaId === null ? 0 : this.datosUsuarioBusqueda.alumno[0].formatoProgramaId),
      idiomaPrograma: new FormControl(this.datosUsuarioBusqueda.alumno[0].idiomaProgramaId === null ? 0 : this.datosUsuarioBusqueda.alumno[0].idiomaProgramaId),
      matricula: new FormControl(''),
      tipoCandidato: new FormControl(this.datosUsuarioBusqueda.alumno[0].tipoCandidatoId === 0 ? 0 : this.datosUsuarioBusqueda.alumno[0].tipoCandidatoId)
    });
    this.renderizarFormulario = true;
    this.programaAcademicoForm.valueChanges.subscribe(val => {
      this.nuevoIngresoService.definirFormularioValidoNuevaSolicitud(this.programaAcademicoForm.valid);
      this.nuevoIngresoService.setChangesAcademicProgram(true);
    });
    this.programaAcademicoForm.get("campus").valueChanges.subscribe(campus => {
      this.onCampusSelected(campus);
      this.programaAcademicoForm.patchValue({
        programaAcademico: 0
      });
    });
    this.onCampusSelected(this.datosUsuarioBusqueda.alumno[0].campusId);
  }

  get programaAcademico() { return this.programaAcademicoForm.get('programaAcademico'); }
  get campus() { return this.programaAcademicoForm.get('campus'); }
  get periodo() { return this.programaAcademicoForm.get('periodo'); }
  get estatusAdmision() { return this.programaAcademicoForm.get('estatusAdmision'); }
  get matricula() { return this.programaAcademicoForm.get('matricula'); }
  get tipoCandidato() { return this.programaAcademicoForm.get('tipoCandidato'); }

  /**
   * Metodo para validar si la institucion usa un identificador personalizado
   */
  public obtenerIdentificador() {
    if (this.identificadorPersonalizado) {
      if (this.estatusAcademicoId === 3) {
        this.matricula.setValidators([Validators.required]);
        this.matricula.updateValueAndValidity();
        this.matricula.setValue("");
      } else {
        this.matricula.setValidators(null);
        this.matricula.updateValueAndValidity();
        this.matricula.setValue("");
      }
    } else {
      this.matricula.setValidators(null);
      this.matricula.updateValueAndValidity();
      this.matricula.setValue("");
    }
  }

  public translate(text: string) {
    return this.i18nextPipe.transform(text, { format: 'cap' });
  }

  private validateId(control: AbstractControl) {
    return control.value === 0 ? { error: 'El campo es requerido' } : null;
  }

  public getTipoCampus() {
    this.subscritpionCampus = this.campusService.obtenerCampus().subscribe(
      (campus: Campus[]) => {
        this.campusList = campus;
      });
  }

  public onCampusSelected(campus: number) {
    this.programaList = [];
    if (!!campus) {
      this.campusService.obtenerProgramas(campus).subscribe(
        programas => {
          this.programaList = programas;
          if (this.programaAcademicoForm.controls['programaAcademico'].value != null) {
            var programa = this.programaList.filter(x => x.programaId == this.programaAcademicoForm.controls['programaAcademico'].value)
            this.nivelID = programa[0].nivelId;
          }
        });
    }
  }

  /**
   * Metodo que se activa el usar el select de estatus
   * @param estatusId 
   */
  public estatusSelected(estatusId: number): void {
    if (estatusId !== 0) {
      this.estatusAcademicoId = estatusId;
      this.obtenerIdentificador();
    }
  }

  public getTipoPeriodo() {
    this.subscriptionPeriodo = this.periodoService.obtenerPeriodos().subscribe(
      (periodo: Periodo[]) => {
        this.periodoList = periodo;
      });
  }

  public GetEstatusAcademicos(): void {
    this.subscriptionPeriodo = this.InscripcionService.GetEstatusAcademicos().subscribe(
      (EstatusAcademico: ApiResponse<EstatusAcademico[]>) => {
        this.estatusAcademicoList = EstatusAcademico.data.filter((estatus) => {
          return estatus.clave == 'ADMTD' || estatus.clave == 'NOADMTD' || estatus.clave == 'CANC' || estatus.clave == 'CANDI' || estatus.clave == 'ALUM'
        });
      });
  }

  public getErrorForm(controlName: string): string {
    let error = '';
    const control = this.programaAcademicoForm.get(controlName);
    if (control.touched && control.errors != null) {
      error = "El campo es requerido";
    }
    return error;
  }

  ngOnDestroy(): void {
    if (this.subscritpionCampus) {
      this.subscritpionCampus.unsubscribe();
    }
    if (this.subscriptionPeriodo) {
      this.subscriptionPeriodo.unsubscribe();
    }
    if (this.subscriptionPrograma) {
      this.subscriptionPrograma.unsubscribe();
    }
  }
}
